"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useApiStateEffect = void 0;
const useApiState_1 = require("./useApiState");
const react_1 = require("react");
const ApiState_1 = require("./ApiState");
const useApiStateEffect = (dispatch, deps, ...props) => {
    const { fetchApiState, apiState, invalidateApiState } = (0, useApiState_1.useApiState)(...props);
    (0, react_1.useEffect)(() => {
        if (!(0, ApiState_1.isApiStateDispatched)(apiState)) {
            fetchApiState(dispatch);
        }
    }, [apiState]);
    (0, react_1.useEffect)(() => {
        if ((0, ApiState_1.isApiStateDispatched)(apiState)) {
            invalidateApiState(); //FIXME this is also called on unmount
        }
    }, deps || []);
    return [apiState, invalidateApiState];
};
exports.useApiStateEffect = useApiStateEffect;
